<template>
  <v-container
    id="profile-documents-view"
    fluid
    tag="section"
  >
    <cumulus-edit-dialog
      ref="editDocument"
      v-model="dialogEditDocument"
      icon="$edit"
      :title="'document'"
      :new-item="new_item"
      can-delete
      @save="saveDocument"
      @remove="removeDocument"
      @new="showDialogEditDocument"
      @escape="closeDialogEditDocument"
    >
      <template v-slot:editform>
        <edit-document
          :document="edited_item"
        />
      </template>
    </cumulus-edit-dialog>

    <material-card
      icon="$documents"
      icon-small
      color="accent"
      :title="page_title"
    >
      <v-card-title>
        <v-btn
          v-shortkey.once="['f2']"
          color="primary"
          class="ma-2"
          @shortkey="showDialogEditDocument()"
          @click="showDialogEditDocument()"
        >
          {{ $t('new_item',{ item: $t('document') }) }}
        </v-btn>
        <v-spacer />
        <v-btn
          v-if="[138,144,217].includes(profile.organization.id) && sourceType === 'user'"
          color="primary"
          @click="getReport({ type: 'airport-use-license', user_id: sourceId})"
        >
          {{ $t('get_airport_use_licences') }}
        </v-btn>
        <v-btn
          color="primary"
          class="ma-2"
          @click="getReport({ type: 'company-authorization', user_id: sourceId, source_name: profile.user_name})"
        >
          {{ $t('get_company_authorization') }}
        </v-btn>
        <v-btn
          color="primary"
          class="ma-2"
          @click="getReport({ type: 'rental-agreement', user_id: sourceId, source_name: profile.user_name})"
        >
          {{ $t('get_rental_agreement') }}
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="items"
          :loading="loading"
          :loading-text="$t('loading')"
          :options.sync="options"
          :server-items-length="total"
          :footer-props="footerProps"
          :item-class="rowClasses"
        >
          <template v-slot:item.document_type="{item}">
            {{ $t('types.' + item.document_type.name_mask) }}
          </template>
          <template #item.actions="{item}">
            <tooltip-btn
              v-for="(action, i) in actions"
              :key="i"
              :color="action.color"
              :icon="action.icon"
              :tooltip="action.tooltip"
              @click="action.func(item)"
            />
          </template>
        </v-data-table>
      </v-card-text>
    </material-card>
  </v-container>
</template>

<script>
  import { call, get, sync } from 'vuex-pathify'
  import EditDocument from '@/layouts/default/edit/Document'
  import { addDays, format } from 'date-fns'

  export default {
    name: 'DocumentsView',
    components: { EditDocument },
    data () {
      return {
        dialogEditDocument: false,
        edited_index: -1,
        edited_item: {},
        items: [],
        footerProps: {
          itemsPerPageOptions: [10, 20, 25, 50, 100],
        },
        total: 0,
        timer: null,
        sourceType: null,
        sourceId: null,
      }
    },
    computed: {
      loading: get('app/loading'),
      profile: get('auth/profile'),
      options: sync('profile/document_options'),
      search: sync('profile/document_search'),
      headers () {
        return [
          {
            align: 'start',
            text: this.$t('fields.document_type_id'),
            value: 'document_type',
          },
          {
            text: this.$t('fields.issue_date'),
            value: 'issue_date',
            sortable: false,
          },
          {
            text: this.$t('fields.expiration_date'),
            value: 'expiration_date',
            sortable: false,
          },
          {
            text: this.$t('actions'),
            value: 'actions',
            sortable: false,
            align: 'right',
          },
        ]
      },
      actions () {
        return [
          { color: 'success', icon: '$show', tooltip: 'tooltip_show', func: this.show },
          { color: 'success', icon: '$edit', tooltip: 'tooltip_edit', func: this.showDialogEditDocument },
        ]
      },
      page_title () {
        return this.$t('my_documents')
      },
      new_item () { return this.edited_index === -1 },
    },
    watch: {
      search: {
        handler () {
          if (this.timer) {
            clearTimeout(this.timer)
            this.timer = null
          }
          this.timer = setTimeout(() => {
            this.options.page = 1
            this.load()
          }, 800)
        },
        deep: true,
      },
      options: {
        handler () {
          this.load()
        },
        deep: true,
      },
    },
    mounted () {
      this.sourceType = this.$route.params.sourcetype ?? 'user'
      this.sourceId = parseInt(this.$route.params.id ?? this.profile.user_id)
      this.load()
    },
    methods: {
      getList: call('profile/search_documents'),
      documentUpdate: call('document/update'),
      documentInsert: call('document/insert'),
      documentDelete: call('document/delete'),
      getDocument: call('exportData/document'),
      getReport: call('action/getReport'),
      fetchDatasource: call('datasource/fetchDatasource'),
      async load () {
        try {
          await this.getList({
          }).then(response => {
            this.items = response.data
            this.total = response.total
          }).catch(e => {
            console.log(e)
          })
        } catch (e) {
        }
      },
      show (document) {
        this.getDocument({
          id: document.id,
          sourceType: 'document',
          type: 'pdf',
        })
      },
      showDialogEditDocument (item) {
        if (!item) {
          this.edited_index = -1
          this.edited_item = {
            element_type: this.sourceType,
            element_id: this.sourceId,
            storage_id: null,
            document_type_id: null,
            recording_date: null,
            issue_date: null,
            expiration_date: null,
            no_expiry: null,
          }
          console.log('új doksi')
        } else {
          this.edited_index = this.items.indexOf(item)
          this.edited_item = Object.assign({}, item)
        }
        this.dialogEditDocument = true
      },
      closeDialogEditDocument () {
        this.dialogEditDocument = false
        this.edited_item = {}
        this.edited_index = -1
      },
      async saveDocument () {
        if (this.edited_index > -1) {
          await this.documentUpdate(
            this.edited_item,
          ).then(response => {
            Object.assign(this.items[this.edited_index], response)
            this.closeDialogEditDocument()
          }).catch(e => {
            this.$refs.editDocument.setErrors(e)
          })
        } else {
          await this.documentInsert(
            this.edited_item,
          ).then(response => {
            this.items.push(response)
            this.total += 1
            this.closeDialogEditDocument()
          }).catch(e => {
            this.$refs.editDocument.setErrors(e)
          })
        }
        console.log(this.edited_item)
      },
      async removeDocument () {
        await this.documentDelete(
          { id: this.edited_item.id },
        ).then(response => {
          this.items.splice(this.edited_index, 1)
          this.total -= 1
          this.closeDialogEditDocument()
        }).catch(e => {
          this.$refs.editDocument.setErrors(e)
          console.log(e)
        })
      },
      rowClasses (item) {
        if (item.expiration_date < format(new Date(), 'yyyy-MM-dd')) {
          console.log(item.enable)
          return 'red lighten-5'
        }
        if (item.expiration_date < format(addDays(new Date(), 15), 'yyyy-MM-dd')) {
          console.log(item.enable)
          return 'yellow lighten-5'
        }
      },
    },
  }

</script>
